import { Button } from '@/components/Button';
import { Container } from '@/components/Container';
import { Reveal } from '@/components/Reveal';
import { hero, type CodeLine } from '@/content/site';
import { cx } from '@/lib/cx';
import styles from './Hero.module.css';

const lineClass: Record<CodeLine['kind'], string | undefined> = {
  code: undefined,
  comment: styles.lineComment,
  output: styles.lineOutput,
};

export function Hero() {
  return (
    <section id="top" className={styles.hero} aria-labelledby="hero-headline">
      <div className={styles.backdrop} aria-hidden="true" />

      <Container className={styles.grid}>
        <Reveal className={styles.copy}>
          <p className={styles.badge}>
            <span className={styles.dot} aria-hidden="true" />
            {hero.eyebrow}
          </p>

          <h1 id="hero-headline" className={styles.headline}>
            {hero.headline.map((part) =>
              part.accent ? <em key={part.text}>{part.text}</em> : <span key={part.text}>{part.text}</span>,
            )}
          </h1>

          <p className={styles.lead}>{hero.lead}</p>

          <div className={styles.ctas}>
            <Button href={hero.primaryCta.href} size="lg" icon="arrowRight">
              {hero.primaryCta.label}
            </Button>
            <Button href={hero.secondaryCta.href} size="lg" variant="secondary">
              {hero.secondaryCta.label}
            </Button>
          </div>

          <dl className={styles.stats}>
            {hero.stats.map((stat) => (
              <div key={stat.label}>
                <dt className="sr-only">{stat.label}</dt>
                <dd>
                  <span className={styles.statValue}>{stat.value}</span>
                  <span className={styles.statLabel} aria-hidden="true">
                    {stat.label}
                  </span>
                </dd>
              </div>
            ))}
          </dl>
        </Reveal>

        <Reveal className={styles.panel} delay={120}>
          <div className={styles.panelBar}>
            <span className={styles.lights} aria-hidden="true">
              <span />
              <span />
              <span />
            </span>
            <span className={styles.panelFile}>{hero.panel.file}</span>
          </div>

          <pre className={styles.codeBlock} tabIndex={0} aria-label={`Example: ${hero.panel.file}`}>
            <code>
              {hero.panel.lines.map((line) => (
                <span key={line.text} className={cx(styles.line, lineClass[line.kind])}>
                  {line.text}
                </span>
              ))}
            </code>
          </pre>
        </Reveal>
      </Container>
    </section>
  );
}
